module.exports = __webpack_public_path__ + "img/project.820681f7.svg";